import React from "react";
import styles from "./Calculator.module.css";

export type CalculatorStatCardProps = {
  label: string;
  value: string;
  subtext: string;
  highlight?: boolean;
  large?: boolean;
};

export const CalculatorStatCard: React.FC<CalculatorStatCardProps> = ({
  label,
  value,
  subtext,
  highlight = false,
  large = false,
}) => (
  <div className={`${styles.statCard} ${highlight ? styles.statCardHighlight : ""}`}>
    <div className={styles.statCardLabel}>{label}</div>
    <div className={`${styles.statCardValue} ${large ? styles.statCardValueLarge : ""}`}>{value}</div>
    <div className={styles.statCardSubtext}>{subtext}</div>
  </div>
);
